import { Row, Col, Form, Input, Select, Button } from "antd";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { getTranslatedValue } from "../../utils/Utils";
import { useEffect, useState } from "react";
import { toSendEmail } from "../../utils/APIs";
import { Link, useLocation } from "react-router-dom";

const Complain = () => {
  const [displayProductError, setDisplayProductError] = useState(false);
  const [product, setProduct] = useState("");
  const [displayMessageError, setDisplayMessageError] = useState(false);
  const [message, setMessage] = useState("");
  const [emailSended, setDisplaySended] = useState(false);

  const sendEmail = () => {
    if (product == "") {
      setDisplayProductError(true);
      return;
    }
    if (message == "") {
      setDisplayMessageError(true);
      return;
    }
    setDisplayProductError(false);
    setDisplayMessageError(false);

    toSendEmail(product, message).then((res) => {
      setDisplaySended(true);
      setMessage("");
      setProduct("");
    });
  };
  return (
    <>
      <HeaderUser />
      <div style={{ marginTop: "2vh" }}>
        <Row>
          <Col
            span={24}
            className="roi--settings-title"
            style={{ marginTop: "1.5vh", textAlign: "center" }}
          >
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="complain" />
            </span>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "6vh" }}>
        <Row offset={2}>
          <Col xl={2} md={1} />

          <Col xl={4} md={6} className="roi--summary-sub-title">
            <span style={{ marginLeft: "1vh" }}>
              <FormattedMessage id="productConcerned" />
            </span>
          </Col>
          <Col
            xl={8}
            md={8}
            className="roi--settings-title"
            style={{ textAlign: "center" }}
          >
            <Input
              onChange={(e) => setProduct(e.target.value)}
              className={
                displayProductError
                  ? "roi--input roi--error-input"
                  : "roi--input"
              }
            />
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "2vh" }}>
        <Row offset={2}>
          <Col xl={2} md={1} />

          <Col
            xl={20}
            md={20}
            className="roi--settings-title"
            style={{ textAlign: "center" }}
          >
            <Input.TextArea
              rows={8}
              onChange={(e) => setMessage(e.target.value)}
              className={
                displayMessageError
                  ? "roi--input roi--error-input"
                  : "roi--input"
              }
              placeholder={getTranslatedValue("message")}
            />
          </Col>
        </Row>
        <div style={{ textAlign: "center" }}>
          <Button
            className="roi--button-primary"
            style={{
              marginTop: "4vh",
              textAlign: "center",
              marginBottom: "2vh",
            }}
            onClick={() => sendEmail()}
          >
            <FormattedMessage id="send" />
          </Button>
          <br />
          <br />
          {emailSended && (
            <span className="roi--email-sended">
              <FormattedMessage id="messageSent" />
            </span>
          )}
        </div>
      </div>
    </>
  );
};
export default Complain;
